export default __webpack_public_path__ + "static/media/dropverse-stack2.webp";